// import { FaStar } from "react-icons/fa";
import React, { useState } from "react";
import { BiMap } from "react-icons/bi";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { useParams } from "react-router-dom";
import "react-tabs/style/react-tabs.css";

import {
  Description,
  Features,
  PriceDetails,
  Reviews,
  Amenities,
  AddReview,
  Trending,
} from "../components/packet-details";

import { packagesData } from "../data/dummyData";

const PacketDetails = () => {
  const { slug } = useParams();
  const packet = packagesData.find((item) => item.slug === slug);
  const [selectedPackage, setSelectedPackage] = useState(null);

  // Debug logging
  React.useEffect(() => {
    console.log("=== PacketDetails Debug ===");
    console.log("slug:", slug);
    console.log("packet found:", packet);
    console.log("packet.packages:", packet?.packages);
    console.log("packages length:", packet?.packages?.length);
    console.log(
      "Has packages condition:",
      !!(packet?.packages && packet?.packages.length > 0),
    );
    console.log("========================");
  }, [slug, packet]);

  if (!packet) {
    return <div className="text-center mt-10 text-xl">Paketa nuk u gjet.</div>;
  }

  const handlePackageSelection = (packageId) => {
    setSelectedPackage(packageId);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="pt-16 px-[3%] md:px-[6%] space-y-20">
      {/* Një paketë e vetme */}
      <div className="space-y-6">
        {/* Header */}
        <div>
          <h1 className="text-3xl md:text-4xl font-bold capitalize">
            {packet.title}
          </h1>
          <div className="mt-2 flex items-center gap-3 text-sm text-gray-700">
            <BiMap />
            <span>{packet.location}</span>
            {/* <FaStar className="text-secondaryYellow" />
            <span>{packet.rating}</span> */}
          </div>
          <div className="flex gap-2 mt-2">
            {packet.tags &&
              packet.tags.map((tag, index) => (
                <span
                  key={index}
                  className="px-2 py-1 text-xs rounded bg-gray-100 text-gray-600"
                >
                  {tag}
                </span>
              ))}
          </div>
        </div>

        {/* Images */}
        <div className="flex flex-wrap gap-4">
          <div className="flex-1 basis-[30rem] overflow-hidden">
            <img
              src={packet.images?.[0] || packet.gallery?.[0] || packet.image}
              alt="main"
              className="w-full h-full object-cover rounded-xl"
            />
          </div>
          <div className="flex-1 basis-[16rem] space-y-3">
            {(packet.images || packet.gallery)?.slice(1).map((img, i) => (
              <img
                key={i}
                src={img}
                alt={`img-${i}`}
                className="w-full h-[150px] object-cover rounded-xl"
              />
            ))}
          </div>
        </div>

        {/* DEBUG: Show packages status */}
        <div className="bg-yellow-100 border border-yellow-400 p-4 rounded">
          <p className="font-bold">DEBUG INFO:</p>
          <p>Has packages: {packet?.packages ? "YES" : "NO"}</p>
          <p>Packages length: {packet?.packages?.length || 0}</p>
          <p>
            Condition result:{" "}
            {String(!!(packet?.packages && packet?.packages.length > 0))}
          </p>
        </div>

        {/* About this experience section with packages */}
        {packet.packages && packet.packages.length > 0 && (
          <div className="bg-white rounded-lg sm:rounded-xl md:rounded-2xl shadow-lg p-3 sm:p-4 md:p-6 lg:p-8">
            <h2 className="flex items-center gap-2 text-base sm:text-lg md:text-xl lg:text-2xl font-bold text-gray-900 mb-4 sm:mb-6 md:mb-8">
              <img
                src="/logo-light-bg.png"
                alt="SeaPulse Logo"
                className="w-8 h-8 sm:w-10 sm:h-10"
              />
              About this experience
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
              {packet.packages.map((pkg) => (
                <div
                  key={pkg.id}
                  className={`bg-white rounded-xl shadow-sm overflow-hidden border transition-all hover:shadow-md ${
                    selectedPackage === pkg.id
                      ? "border-gray-900 shadow-md"
                      : "border-gray-200"
                  }`}
                >
                  <div className="relative h-48 sm:h-56 overflow-hidden">
                    <img
                      src={pkg.image}
                      alt={pkg.name}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute top-3 right-3 bg-white/95 backdrop-blur-sm text-gray-900 px-3 py-1.5 rounded-md text-xs font-bold border border-gray-200">
                      PACKAGE {pkg.id}
                    </div>
                  </div>
                  <div className="p-5 sm:p-6">
                    <div className="border border-gray-200 rounded-lg p-4 mb-4 text-center bg-gray-50">
                      <p className="text-xs text-gray-600 font-semibold uppercase tracking-wider mb-1">
                        Duration
                      </p>
                      <p className="text-3xl font-bold text-gray-900">
                        {pkg.duration}
                      </p>
                    </div>
                    <div className="bg-gray-900 text-white text-center py-2 px-2 sm:py-3 sm:px-4 rounded-md sm:rounded-lg mb-4 sm:mb-5 max-w-[140px] sm:max-w-full mx-auto">
                      <p className="text-xl sm:text-2xl font-bold">
                        €{pkg.price_per_person}
                      </p>
                      <p className="text-xs font-medium opacity-90">
                        per person
                      </p>
                      {pkg.price_per_group && (
                        <>
                          <div className="my-2 border-t border-white/20"></div>
                          <p className="text-lg sm:text-xl font-bold">
                            €{pkg.price_per_group}
                          </p>
                          <p className="text-xs font-medium opacity-90">
                            per group
                          </p>
                        </>
                      )}
                    </div>
                    <ul className="space-y-3 mb-5">
                      {pkg.included.map((item, index) => (
                        <li key={index} className="flex items-start gap-3">
                          <svg
                            className="w-5 h-5 text-gray-900 flex-shrink-0 mt-0.5"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clipRule="evenodd"
                            />
                          </svg>
                          <span className="text-sm text-gray-700 leading-relaxed">
                            {item}
                          </span>
                        </li>
                      ))}
                    </ul>
                    <button
                      onClick={() => handlePackageSelection(pkg.id)}
                      className={`w-full py-2 sm:py-2.5 rounded-md sm:rounded-lg font-medium text-sm sm:text-base transition-all border ${
                        selectedPackage === pkg.id
                          ? "bg-gray-900 text-white border-gray-900"
                          : "bg-white text-gray-900 border-gray-300 hover:bg-gray-900 hover:text-white hover:border-gray-900"
                      }`}
                    >
                      {selectedPackage === pkg.id
                        ? "✓ Selected"
                        : "Select Package"}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Tabs */}
        <div>
          <Tabs>
            <TabList>
              <Tab>Description</Tab>
              <Tab>Features</Tab>
              <Tab>Price</Tab>
              <Tab>Reviews</Tab>
            </TabList>
            <TabPanel>
              <Description description={packet.description} />
            </TabPanel>
            <TabPanel>
              <Features features={packet.features} />
            </TabPanel>
            <TabPanel>
              <PriceDetails price={packet.price} packages={packet.packages} />
            </TabPanel>
            <TabPanel>
              <Reviews reviews={packet.reviews} />
            </TabPanel>
          </Tabs>
        </div>

        <Amenities amenities={packet.amenities} />
        <AddReview packetId={packet.id} />
      </div>

      <Trending currentPacketId={packet.id} />
    </div>
  );
};

export default PacketDetails;
